import React, { FC } from 'react'
import { FormSelect, FormSelectProps } from '@docpace/shared-react-components/FormSelect'
import { AppointmentCycleStatsType} from '@docpace/shared-ts-types'

export const MuiFormAppointmentCycleStatsTypeSelect: FC<Omit<FormSelectProps, 'options'>> = ({
    ...props
}) => {
    return (
        <FormSelect {...props} options={[
            { value: null, label: 'None' },
            { value: AppointmentCycleStatsType.PRACTICE, label: 'Practice' },
            { value: AppointmentCycleStatsType.PROVIDER, label: 'Provider' },
        ]} />
    )
}
